module.exports = __webpack_public_path__ + "static/media/american-exp-icon.6ef46fe9.svg";